import { styled } from 'parkdepot-shared/theme'

export const WarningTextContainer = styled('div', ({ $theme }) => ({
    backgroundColor: '#F7F7FF',
    padding: '8px',
    display: 'flex',
    gap: '8px',
    alignItems: 'center',
    borderRadius: '1.6rem',

    [$theme.mediaQuery.large]: {
        padding: '16px'
    }
}))

export const WarningIcon = styled('i', ({ $theme }) => ({
    color: $theme.colors.primary,
    fontSize: '12px',
    fontWeight: 600
}))

export const WarningList = styled('ul', ({ $theme }) => ({
    margin: 0,
    padding: '0 0 0 20px'
}))

export const WarningText = styled('li', ({ $theme }) => ({
    ...$theme.typography.ParagraphSmall,
    margin: 0,
    fontSize: '12px',
    lineHeight: '18px',
    color: $theme.colors.primary,
    fontWeight: 700
}))
